import React, { useLayoutEffect, useState } from "react";

import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import InputLabel from "@mui/material/InputLabel";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import JobService from "../../service/job";

import { useDispatch } from "react-redux";
import { showToast } from "../../store/actions";

const useStyles = makeStyles((theme) =>
  createStyles({
    gridItem: {
      minHeight: "90px",
    },
    paper: {
      height: "100%",
      padding: "10px 20px",
    },
  })
);

const Addon = ({ setStatus, job_id, jobAddons, role, isSupplierJob, status }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [boxLayoutHeight, setBoxLayoutHeight] = useState(0);
  const [addons, setAddons] = useState(JSON.parse(JSON.stringify(jobAddons)));
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    function updateSize() {
      setBoxLayoutHeight(window.innerHeight - 205);
    }
    window.addEventListener("resize", updateSize);
    updateSize();

    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const handleSampleSubmit = async () => {
    setLoading(true);
    const Job = new JobService();

    const formData = new FormData();
    formData.append("addons", JSON.stringify(addons));

    let status = null;
    const newTrackingNo = addons?.find((addon) => addon.text === "Tracking Number or Vessel Date Saling");
    const oldTrackingNo = jobAddons?.find((addon) => addon.text === "Tracking Number or Vessel Date Saling");
    if (newTrackingNo?.value && !oldTrackingNo.value) status = 9;

    const newDateDelivered = addons?.find((addon) => addon.text === "Job Completed Delivery Date Confirmed");
    const oldDateDelivered = jobAddons?.find((addon) => addon.text === "Job Completed Delivery Date Confirmed");
    if (newDateDelivered?.value && !oldDateDelivered.value) status = 10;

    if (status) formData.append("Status", status);

    Job.updateJob(job_id, formData).then((response) => {
      if (response.success) {
        if (status) setStatus(status);
        dispatch(
          showToast({
            type: "success",
            message: "Addons saved successfully!",
          })
        );
      }

      setLoading(false);
    });
  };

  return (
    <>
      <Backdrop sx={{ color: "red", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="primary" />
      </Backdrop>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            overflowY: "auto",
            height: `${boxLayoutHeight}px`,
            maxHeight: `${boxLayoutHeight}px`,
          }}
        >
          <Paper className={classes.paper}>
            <Grid container spacing={2} height="100%">
              {addons.map((addon, index) => (
                <Grid item xs={4} className={classes.gridItem} key={addon.addon_id}>
                  <InputLabel sx={{ mt: 1 }} className="inputFormCustomLabel">
                    {addon.text}
                  </InputLabel>
                  {role === 3 || addon.text !== "Job Completed Delivery Date Confirmed" ? (
                    <TextField
                      margin="normal"
                      fullWidth
                      value={addon.value}
                      onInput={(e) =>
                        setAddons((prev) => {
                          prev[index].value = e.target.value;
                          return [...prev];
                        })
                      }
                      variant="filled"
                      hiddenLabel
                      size="small"
                      placeholder={"Enter " + addon.text + " Here"}
                      sx={{ mt: 1 }}
                      disabled={role === 3}
                    />
                  ) : (
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDatePicker
                        value={addon.value}
                        disablePast
                        onChange={(date) => {
                          setAddons((prev) => {
                            prev[index].value = date ? new Date(date).toISOString().slice(0, 19).replace("T", " ") : "";
                            return [...prev];
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            margin="normal"
                            sx={{ mt: 1, cursor: "pointer", input: { cursor: "pointer" } }}
                            fullWidth
                            variant="filled"
                            size="small"
                            hiddenLabel
                            {...params}
                            InputProps={{
                              readOnly: true,
                            }}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  )}
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Box>
      </Box>
      {(role === 1 || role === 2 || (isSupplierJob && role === 4 && status > 7)) && (
        <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
          <Box sx={{ flex: "1 1 auto" }} />
          <Button
            variant="contained"
            size="small"
            onClick={handleSampleSubmit}
            style={{
              backgroundColor: "#3a3d4a",
              padding: "5px 20px",
            }}
          >
            Save
          </Button>
        </Box>
      )}
    </>
  );
};

export default React.memo(Addon);
